import { render, staticRenderFns } from "./PlayerProfileEmbed.vue?vue&type=template&id=234b47ad&"
import script from "./PlayerProfileEmbed.vue?vue&type=script&lang=js&"
export * from "./PlayerProfileEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports